module.exports = __webpack_public_path__ + "img/project18_3.png.31b24b0a.webp";